<template>
    <app-layout title="Varia">
        <template #header>
            <page-title title="Varia" />
        </template>

        <template #pageContent>
            <ul>
                <li v-if="this.$page.props.user.permissions.includes('templates.postinvoice')">
                    <a href="/various/download-template-post-invoice" >
                        Sjabloon nafacturatie downloaden
                    </a>
                </li>
            </ul>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'

import { Link } from '@inertiajs/inertia-vue3';

export default {
    components: {
        AppLayout,
        PageTitle,
        Link
    },
}

</script>
